import mixpanel from "mixpanel-browser";

export const initMixpanel = ({ token, userId }) => {
  if (!token) {
    console.error("Mixpanel token is required!");
    return;
  }

  if (mixpanel.__loaded) {
    console.info("Mixpanel already initialized");
    return;
  }

  mixpanel.init(token, { debug: true, ignore_dnt: true });

  if (userId) {
    mixpanel.identify(userId);
  }

  console.info("Mixpanel initialized:", token);
};

export const logEventMixpanel = (eventName, params = {}) => {
  if (!mixpanel.__loaded) {
    console.warn("Mixpanel not initialized, skipping event:", eventName);
    return;
  }

  mixpanel.track(eventName, params, (res) => {
    if (res === 1) {
      console.log("✅ Mixpanel captured event:", eventName, params);
    } else {
      console.warn("❌ Mixpanel failed to capture event:", eventName, params);
    }
  });
};

export const setUserPropertiesMixpanel = (props = {}) => {
  if (!mixpanel.__loaded) {
    console.warn("Mixpanel not initialized, skipping set properties");
    return;
  }

  mixpanel.people.set(props);
  console.log("Mixpanel user properties:", props);
};
